import * as PIXI from 'pixi.js';
import { Entity } from '../core/EntityManager';

export class Exit extends Entity {
  private doorClosed: PIXI.Graphics;
  private doorOpen: PIXI.Graphics;
  private activeIndicator: PIXI.Graphics;

  constructor() {
    super();
    this.radius = 24;

    // Closed door (locked)
    this.doorClosed = new PIXI.Graphics();
    this.doorClosed.roundRect(-20, -30, 40, 60, 4);
    this.doorClosed.fill(0x8B4513);
    this.doorClosed.rect(-16, -26, 32, 52);
    this.doorClosed.fill(0xA0522D);
    // Lock
    this.doorClosed.circle(0, 0, 5);
    this.doorClosed.fill(0xFFD700);
    this.sprite.addChild(this.doorClosed);

    // Open door (unlocked)
    this.doorOpen = new PIXI.Graphics();
    this.doorOpen.roundRect(-20, -30, 40, 60, 4);
    this.doorOpen.fill(0x228B22);
    this.doorOpen.rect(-16, -26, 32, 52);
    this.doorOpen.fill(0x32CD32);
    // Arrow
    this.doorOpen.moveTo(0, -10);
    this.doorOpen.lineTo(-8, 0);
    this.doorOpen.lineTo(8, 0);
    this.doorOpen.closePath();
    this.doorOpen.fill(0xFFFFFF);
    this.doorOpen.visible = false;
    this.sprite.addChild(this.doorOpen);

    // Animated indicator
    this.activeIndicator = new PIXI.Graphics();
    this.activeIndicator.circle(0, -35, 4);
    this.activeIndicator.fill(0xFFD700);
    this.sprite.addChild(this.activeIndicator);
  }

  setObjectiveComplete(complete: boolean): void {
    this.doorClosed.visible = !complete;
    this.doorOpen.visible = complete;
  }

  update(_dt: number, _tick: number): void {
    const scale = 1 + Math.sin(Date.now() / 300) * 0.15;
    this.activeIndicator.scale.set(scale);
  }

  isActive(): boolean {
    return this.active;
  }
}
